module.exports = __webpack_public_path__ + "img/mc_symbol.043cc83.svg";